<template>
  <div>
    <v-select
      :menu-props="{ bottom: true, offsetY: true, maxHeight: 200  }"
      label="Schema type"
      v-model="type"
      :items="list || SCHEMA_TYPES"
      data-test="schemaType"
      @input="handleChangeType"
      item-text="title"
      item-value="value"
    >
      <template v-slot:item="item">
        <div :data-test-object="item.item.title">
          {{ item.item.title }}
        </div>
      </template>
    </v-select>

    <v-autocomplete
      clearable
      data-test-schema
      :menu-props="{ maxHeight: 200 }"
      v-on="$listeners"
      v-bind="{ ...$attrs, ...$props }"
      :loading="loading"
      :disabled="loading"
      :items="schemas"
      item-text="name"
      item-value="id"
      label="Schema"
      class="ma-0"
    >
      <template v-slot:item="item">
        <div :data-test-schema="item.item.name">
          {{ item.item.name }}
        </div>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import { useLazyQuery, useResult } from '@vue/apollo-composable';
import schema from '@/api/schemas/list.graphql';
import { onMounted, reactive, ref, toRefs, watch } from '@vue/composition-api';

const SCHEMA_TYPES = [
  { value: 'media', title: 'Media' },
  { value: 'device', title: 'Device' },
  { value: 'dataset', title: 'Dataset' },
  { value: 'monitor', title: 'Monitor objects' },
  { value: 'stat', title: 'Statistic objects' },
  { value: 'application', title: 'Application' }
];

export default {
  name: 'CommonSchemaSelector',
  props: {
    schemaType: {
      type: String,
      default: 'device'
    },
    list: {
      type: Array,
      default: () => []
    }
  },
  setup(props, { emit }) {
    const localState = reactive({
      type: props.schemaType
    });

    const filter = ref({});
    const lazyQuery = useLazyQuery(
      schema.loadPure,
      {
        filter
      },
      {
        fetchPolicy: 'network-only',
        nextFetchPolicy: 'network-only'
      }
    );

    const schemas = useResult(lazyQuery.result, [], data => {
      return data.schemata;
    });

    const handleChangeType = e => {
      emit('schema-type', localState.type);
      if (localState.type === 'monitor') {
        filter.value = {
          parentSchemaExists: false,
          type: {
            equalTo: 'DATASET'
          },
          mTags: {
            contains: ['application', 'monitor']
          },
          enabled: {
            equalTo: true
          },
          objectsCount: {
            greaterThan: 0
          }
        };
      } else if (localState.type === 'stat') {
        filter.value = {
          parentSchemaExists: false,
          type: {
            equalTo: 'DATASET'
          },
          enabled: {
            equalTo: true
          },
          mTags: {
            contains: ['application', 'statistics']
          },
          objectsCount: {
            greaterThan: 0
          }
        };
      } else {
        filter.value = {
          parentSchemaExists: false,
          objectsCount: {
            greaterThan: 0
          },
          type: {
            equalTo: localState.type.toUpperCase()
          },
          enabled: {
            equalTo: true
          }
        };
      }

      lazyQuery.load();
    };

    onMounted(() => {
      handleChangeType();
    });

    watch(
      () => props.schemaType,
      () => {
        localState.type = props.schemaType;
        handleChangeType();
      }
    );

    return {
      ...toRefs(localState),
      handleChangeType,
      loading: lazyQuery.loading,
      schemas,
      SCHEMA_TYPES
    };
  }
};
</script>
